import { Button, Input, Select, Form, Drawer, message, Tooltip } from "antd";
import { useEffect, useState } from "react";
import axios from "axios";
import { CloseOutlined, FileImageOutlined } from "@ant-design/icons";

import config from "../../utils/config.js";
import endpoints from "../../utils/endpoints.js";

import Media from "../Media/media.js";

const { Option } = Select;

function DrawerEditCommission({ data, open, close }) {
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isOpenMedia, setIsOpenMedia] = useState(false);
  const [mediaKey, setMediaKey] = useState(null);

  const [form] = Form.useForm();

  useEffect(() => {
    if (data) form.setFieldsValue(data);
  }, [data]);

  function submit(values) {
    setIsButtonLoading(true);

    axios
      .post(endpoints.committee.update, {
        data: values,
      })
      .then((res) => {
        closeDrawer();
        message.success("Membro da comissão foi editado com sucesso!");
      })
      .catch((error) => {
        console.log(error);
        setIsButtonLoading(false);
        message.error("Algo de errado aconteceu! Tente novamente mais tarde.");
      });
  }

  function closeDrawer() {
    form.resetFields();
    setIsButtonLoading(false);
    close();
  }

  function openMedia(k) {
    setMediaKey(k);
    setIsOpenMedia(true);
  }

  function closeMedia(res) {
    if (res) {
      form.setFieldValue(mediaKey, res[mediaKey]);
    }

    setMediaKey(null);
    setIsOpenMedia(false);
  }

  return (
    <Drawer
      width={800}
      className="drawer-antd-committee"
      title={`Editar membro`}
      open={open}
      onClose={closeDrawer}
      maskClosable={false}
      extra={[
        <Button className="mr-2" size="large" type="primary" onClick={form.submit} loading={isButtonLoading} disabled={isButtonLoading}>
          Guardar
        </Button>,
        <Button size="large" onClick={closeDrawer}>
          Cancelar
        </Button>,
      ]}
    >
      <Media mediaKey={mediaKey} open={isOpenMedia} close={closeMedia} />
      <Form form={form} id="add-moderator-form" layout="vertical" onFinish={submit}>
        <Form.Item hidden name="id">
          <Input />
        </Form.Item>
        <Form.Item name="type" label="Tipo" rules={[{ required: true, message: "Este é um campo obrigatório" }]}>
          <Select
            showSearch
            allowClear
            size="large"
            placeholder="Tipo de comissão..."
            filterOption={(input, option) => (option?.children ?? "").toLowerCase().includes(input.toLowerCase())}
            options={["Steering", "Scientific"].map((value, index) => ({
              label: value,
              value: value,
            }))}
          />
        </Form.Item>
        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.img !== currentValues.img}>
          {({ getFieldValue }) => {
            return (
              <div className="relative">
                <p className="pb-[8px]">Imagem</p>
                <div
                  className="relative border border-dashed border-gray-300 mb-6 cursor-pointer flex justify-center items-center h-[120px] w-full overflow-hidden"
                  onClick={() => openMedia("img")}
                  style={{
                    backgroundImage: `url(${config.server_ip}media/${getFieldValue("img")})`,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  {!getFieldValue("img") ? (
                    <div className="flex justify-center items-center flex-col p-10">
                      <FileImageOutlined className="text-[30px]" /> <p className="text-[11px] text-center mt-2">Selecionar Imagem</p>
                    </div>
                  ) : null}
                </div>

                <Form.Item name={"img"} hidden>
                  <Input />
                </Form.Item>

                {getFieldValue("img") && (
                  <div className="absolute top-[12px] right-[-10px]">
                    <Tooltip placement="bottom" title={"Remover imagem"}>
                      <Button icon={<CloseOutlined />} onClick={() => form.setFieldValue("img", null)}></Button>
                    </Tooltip>
                  </div>
                )}
              </div>
            );
          }}
        </Form.Item>
        <Form.Item name="name" label="Nome" rules={[{ required: true, message: "Este é um campo obrigatório" }]}>
          <Input size="large" placeholder="Nome..." />
        </Form.Item>
        <Form.Item name="work" label="Local de trabalho/Afiliação">
          <Input size="large" placeholder="Local de trabalho/Afiliação..." />
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export default DrawerEditCommission;
